const qs = (query, container = document) => {
  return container.querySelector(query);
};

const qsAll = (query, container = document) => {
  return [...container.querySelectorAll(query)];
};

export { qs, qsAll };